import Vue from 'vue'

import Skeleton from 'vant/lib/skeleton'
import 'vant/lib/skeleton/style'

import Loading from 'vant/lib/loading'
import 'vant/lib/loading/style'

import Toast from 'vant/lib/toast'
import 'vant/lib/toast/style'

import Lazyload from 'vant/lib/lazyload'
import 'vant/lib/lazyload/style'

import Image from 'vant/lib/image'
import 'vant/lib/image/style'

import Icon from 'vant/lib/icon'
import 'vant/lib/icon/style'

import Popup from 'vant/lib/popup'
import 'vant/lib/popup/style'

import Swipe from 'vant/lib/swipe'
import 'vant/lib/swipe/style'

import SwipeItem from 'vant/lib/swipe-item'
import 'vant/lib/swipe-item/style'

import CountDown from 'vant/lib/count-down'
import 'vant/lib/count-down/style'

import Form from 'vant/lib/form'
import 'vant/lib/form/style'

import Field from 'vant/lib/field'
import 'vant/lib/field/style'

import Picker from 'vant/lib/picker'
import 'vant/lib/picker/style'

import Empty from 'vant/lib/empty'
import 'vant/lib/empty/style'

import Uploader from 'vant/lib/uploader'
import 'vant/lib/uploader/style'

import Button from 'vant/lib/button'
import 'vant/lib/button/style'

import NoticeBar  from 'vant/lib/notice-bar'
import 'vant/lib/notice-bar/style'
Vue.use(Skeleton)
Vue.use(Loading)
Vue.use(Toast)
Vue.use(Lazyload)
Vue.use(Image)
Vue.use(Icon)
Vue.use(Popup)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(CountDown)
Vue.use(Form)
Vue.use(Field)
Vue.use(Picker)
Vue.use(Empty)
Vue.use(Uploader)
Vue.use(Button)
Vue.use(NoticeBar)

Vue.prototype.$toast = Toast
